import React, { PureComponent } from 'react'
import { tableHeader } from './style'
import classnames from 'classnames'

class TableHeader extends PureComponent {
  static propTypes = {}

  static defaultProps = {}

  render() {
    const { fields, tableGuid, scrollTable } = this.props

    return (
      <div
        className={classnames('table-header-container', {
          scroll: scrollTable
        })}
      >
        {fields.map((field, index) => (
          <div
            className="table-header-field"
            key={`${tableGuid}-${index}`}
            style={{ width: field.width }}
          >
            {field.caption}
          </div>
        ))}
        <style jsx>{tableHeader}</style>
      </div>
    )
  }
}

export default TableHeader
